var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftChevronIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.84163 9.40834L3.02496 5.58334L6.84163 1.75834L5.66663 0.583344L0.666626 5.58334L5.66663 10.5833L6.84163 9.40834Z",
    fill: "#eb672d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftChevronIcon);
export default __webpack_public_path__ + "static/media/leftChevronIcon.b03fdb0ca981df3357e9f14faae7ef13.svg";
export { ForwardRef as ReactComponent };